import { render } from "./left-button.vue?vue&type=template&id=2be94929&scoped=true"
const script = {}

import "./left-button.vue?vue&type=style&index=0&id=2be94929&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be94929"]])

export default __exports__